import useRoleBasedRedirect from "@/hooks/RoleBasedRedirect";

const ForgottenEmail = () => {
  useRoleBasedRedirect(null);

  return <div>TODO</div>;
};

export default ForgottenEmail;
